import { createSelector } from 'redux-bundler';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';
import urlFormatter from 'utils/urlFormatter';

import {
  ERROR,
  GENERAL,
  HATCH_APP_ROUTE,
  PRIVATE_URLS,
  PUBLIC_URLS_WITHOUT_ERROR_REDIRECT,
  REDIRECT_PATHS,
} from '../../routes/APP_URLS';

export const reactRedirects = createSelector(
  'selectIsFetchingSession',
  'selectHasCheckedSession',
  'selectIsLoggedIn',
  'selectFreshUserKey',
  'selectAllOrganizationIDs',
  'selectRouteInfo',
  (
    isFetchingSession,
    hasCheckedSession,
    isLoggedIn,
    { organizations: freshOrganizations },
    allOrganizationIDs,
    { url: pathname, params: { organizationId }, pattern },
  ) => {
    // TODO: handle not manager role
    if (!isFetchingSession && hasCheckedSession && !isLoggedIn) return null;

    // first organization in the list is the default
    const defaultOrganization =
      isCorrectHatchIdFormat(allOrganizationIDs[0]) && allOrganizationIDs[0];

    if (Object.keys(REDIRECT_PATHS).some((item) => item === pathname)) {
      if (allOrganizationIDs && allOrganizationIDs.length > 0) {
        const url = REDIRECT_PATHS[pathname].replace(
          '[[organizationID]]',
          allOrganizationIDs[0],
        );
        window.location.replace(url);
      }
    }

    // if user is logged in, routes to ROOT, has fetched their orgs, and has a default organization
    // if organization IDs call fails, then we will have routed you to the error page in the action
    if (
      PUBLIC_URLS_WITHOUT_ERROR_REDIRECT.includes(pathname) &&
      freshOrganizations &&
      defaultOrganization
    ) {
      return {
        actionCreator: 'doUpdateUrl',
        args: [
          urlFormatter({ organizationId: defaultOrganization, url: GENERAL }),
        ],
      };
    }

    // if user is logged in, routes to ROOT, has fetched their orgs but has no organizations, redirect to V2
    if (
      PUBLIC_URLS_WITHOUT_ERROR_REDIRECT.includes(pathname) &&
      freshOrganizations &&
      !defaultOrganization
    ) {
      return window.location.replace(HATCH_APP_ROUTE);
    }

    // if we've fetched organization but the typed URL is not a valid hatch ID or the passed ID is not
    // in the user list of organizations
    if (
      ((PRIVATE_URLS.includes(pattern) &&
        freshOrganizations &&
        !isCorrectHatchIdFormat(organizationId)) ||
        (PRIVATE_URLS.includes(pattern) &&
          freshOrganizations &&
          !allOrganizationIDs.includes(organizationId))) &&
      pathname !== ERROR
    ) {
      // TODO: route to error page
      return { actionCreator: 'doUpdateUrl', args: [ERROR] };
    }

    // remove trailing slash if present, except for root url
    if (pathname !== '/' && pathname.endsWith('/')) {
      return { actionCreator: 'doReplaceUrl', args: [pathname.slice(0, -1)] };
    }

    return null;
  },
);
